import { render, staticRenderFns } from "./QCMAnswerItem.vue?vue&type=template&id=af4b111e&scoped=true&"
import script from "./QCMAnswerItem.vue?vue&type=script&lang=js&"
export * from "./QCMAnswerItem.vue?vue&type=script&lang=js&"
import style0 from "./QCMAnswerItem.vue?vue&type=style&index=0&id=af4b111e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4b111e",
  null
  
)

export default component.exports